import React from "react";
import PropTypes from "prop-types";
import {
  Container,
  Header,
  SectionTitle,
  LegTitle,
  Details,
  Row,
  ColLabel,
  ColValue,
  Divider,
} from "./styles";

function ProductAereo({ itinerary }) {
  const data = itinerary || {};

  return (
    <Container role="region" aria-label="Resumo das passagens aéreas">
      <Header>
        <SectionTitle>{data.title || '-'}</SectionTitle>
      </Header>

      {Array.isArray(data.legs) && data.legs.map((leg, idx) => (
        <div key={idx}>
          <LegTitle>{leg.label || '-'}</LegTitle>
          <Details>
            <Row>
              <ColLabel>Companhia aérea:</ColLabel>
              <ColValue>{leg.airline || '-'}</ColValue>
            </Row>
            <Row>
              <ColLabel>Código da reserva:</ColLabel>
              <ColValue>{leg.locator || '-'}</ColValue>
            </Row>
            <Row>
              <ColLabel>Número do voo:</ColLabel>
              <ColValue>{leg.flightNumber || '-'}</ColValue>
            </Row>
            <Row>
              <ColLabel>Nome dos passageiros:</ColLabel>
              <ColValue>{leg.passengers || '-'}</ColValue>
            </Row>
            <Row>
              <ColLabel>Origem:</ColLabel>
              <ColValue>{leg.origin || '-'}</ColValue>
            </Row>
            <Row>
              <ColLabel>Destino:</ColLabel>
              <ColValue>{leg.destination || '-'}</ColValue>
            </Row>
            <Row>
              <ColLabel>Data e horário de partida:</ColLabel>
              <ColValue>{leg.departure || '-'}</ColValue>
            </Row>
            <Row>
              <ColLabel>Data e horário de chegada:</ColLabel>
              <ColValue>{leg.arrival || '-'}</ColValue>
            </Row>
            {leg.layover && (
              <Row>
                <ColLabel>Espera de:</ColLabel>
                <ColValue>{leg.layover || '-'}</ColValue>
              </Row>
            )}
          </Details>
          {Array.isArray(leg.stops) && leg.stops.length > 0 && (
            <>
              <Divider />
              <LegTitle>Paradas</LegTitle>
              {leg.stops.map((stop, sIdx) => (
                <Details key={sIdx}>
                  <Row>
                    <ColLabel>Companhia aérea:</ColLabel>
                    <ColValue>{stop.airline || '-'}</ColValue>
                  </Row>
                  <Row>
                    <ColLabel>Código da reserva:</ColLabel>
                    <ColValue>{stop.locator || '-'}</ColValue>
                  </Row>
                  <Row>
                    <ColLabel>Número do voo:</ColLabel>
                    <ColValue>{stop.flightNumber || '-'}</ColValue>
                  </Row>
                  <Row>
                    <ColLabel>Nome dos passageiros:</ColLabel>
                    <ColValue>{stop.passengers || '-'}</ColValue>
                  </Row>
                  <Row>
                    <ColLabel>Origem:</ColLabel>
                    <ColValue>{stop.origin || '-'}</ColValue>
                  </Row>
                  <Row>
                    <ColLabel>Destino:</ColLabel>
                    <ColValue>{stop.destination || '-'}</ColValue>
                  </Row>
                  <Row>
                    <ColLabel>Data e horário de partida:</ColLabel>
                    <ColValue>{stop.departure || '-'}</ColValue>
                  </Row>
                  <Row>
                    <ColLabel>Data e horário de chegada:</ColLabel>
                    <ColValue>{stop.arrival || '-'}</ColValue>
                  </Row>
                  {stop.waitTime && (
                    <Row>
                      <ColLabel>Tempo de espera:</ColLabel>
                      <ColValue>{stop.waitTime || '-'}</ColValue>
                    </Row>
                  )}
                </Details>
              ))}
            </>
          )}
          {Array.isArray(data.legs) && idx < data.legs.length - 1 && <Divider />}
        </div>
      ))}
    </Container>
  );
}

ProductAereo.propTypes = {
  itinerary: PropTypes.shape({
    title: PropTypes.string,
    legs: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        airline: PropTypes.string,
        locator: PropTypes.string,
        flightNumber: PropTypes.string,
        passengers: PropTypes.string,
        origin: PropTypes.string,
        destination: PropTypes.string,
        departure: PropTypes.string,
        arrival: PropTypes.string,
        layover: PropTypes.string,
      })
    ),
  }),
};

ProductAereo.defaultProps = {
  itinerary: null,
};

export default ProductAereo;


